<template>
    <div class="canary-wharf-group">
        <div class="intermediary-header">
            <p>
                We’re transferring you to the Canary Wharf pre-book platform.
            </p>
        </div>
        <img class="powered-by" src="/images/whitelabel/canary-whraf/powered-by-yps.png" alt="powered by yps">
        <img class="cover-photo" src="/images/whitelabel/canary-whraf/highlight-photo.jpeg" alt="highlight photo">
        <div class="intermediary-body">
            <p>
                Please note that you will need to
                <span>
                    register with new account details
                </span>
                when booking parking for the first time,
                you won't be able to use your Canary Wharf app login details.
            </p>
            <p>
                For any support enquiries,
                including assistance with registering for an account,
                please contact us
            </p>
            <p>
                at:
                <u>
                    car.parks@canarywharf.com
                </u>
            </p>
        </div>
        <div class="intermediary-footer">
            <a :href="listingsUrl" class="btn btn-primary">
                Book parking
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'canary-wharf-group',

        computed: {
            /**
             * Route to the listings page.
             *
             * @returns {String}
             */
            listingsUrl() {
                return '/listings';
            },
        },
    };
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import (reference) "~assets/less/variables.less";

    .canary-wharf-group {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 1440px;
        margin: 0 auto;
    }

    .intermediary-header {
        margin: 0 30px;

        p {
            color: #101921;
            font-family: VisueltPro;
            font-size: 24px;
            font-style: normal;
            font-weight: 500;
            line-height: 28px;
            margin: 0;

            @media (min-width: @screen-tablet) {
                font-size: 28px;
            }
        }
    }

    .powered-by {
        align-self: flex-start;
        height: 85px;
        margin: 0 19px;
    }

    .cover-photo {
        margin-top: -8px;
    }

    .intermediary-body {
        margin: 21px 31px 0;

        p {
            color: #003e52;
            font-family: VisueltPro;
            font-size: 14px;
            font-style: normal;
            font-weight: 300;
            line-height: 24px;
            margin: 0;

            @media (min-width: @screen-tablet) {
                font-size: 18px;
            }
        }

        span, u {
            font-weight: 500;
        }

        a {
            color: inherit;
            font-weight: 500;
            text-decoration: underline;
        }
    }

    .intermediary-footer {
        margin: 15px 31px 37px;

        a {
            align-items: center;
            justify-content: center;
            background-color: #0312f5;
            color: #ffffff;
            display: flex;
            font-family: Mont;
            height: 46px;
            width: 100%;
        }
    }
</style>
